import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { StatementsFacade } from '../services/statements.facade';

@Injectable({
  providedIn: 'root',
})
export class CanSeeStatementsGuard {
  constructor(
    private router: Router,
    private statementsService: StatementsFacade
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.statementsService.showOwnerStatements$.pipe(
      take(1),
      map((showOwnerStatements) => {
        if (!showOwnerStatements) {
          const redirectPath = route.data.redirectPath ?? '/operations';
          return this.router.createUrlTree([redirectPath]);
        }
        return true;
      })
    );
  }
}
